<div id="methods-banner" class="methods-bg container-fluid px-0"
  [style.backgroundImage]="backgroundImage | blobstorage:'style' ">
  <div class="container row mx-auto pt-3 pt-md-5 justify-content-around">
    <div class="d-flex col-12 col-md-6">
      <span class="mx-auto my-auto text-center text-md-left msb fs-xxl">{{'Tus proyectos crecen más al estar en Internet' | translate}} </span>
    </div>
    <div class="service-img-container col-12 col-md-6 col-lg-5">
      <img loading="lazy" src="{{ '/images/meeting.svg' | blobstorage }}" alt="CpanelFt">
    </div>
  </div>
</div>

<section id="methods-content" class="pm container">
  <h1 class="pm-title mb-3">{{'Formas de Pago' | translate}}</h1>

  <p class="pm-intro mb-4">{{'Las formas de pago disponibles pueden variar según el servicio, el nombre de dominio y el trámite que estés realizando: contratación, registro, renovación o recuperación. Una vez confirmado el pago, tus servicios se activan. Los tiempos de confirmación pueden variar según el método de pago, banco, comercio y horario.' | translate}}</p>

  <ul class="pm-grid">

    <!-- Tarjeta de crédito o débito -->
    <li>
      <article class="pm-card">
        <span class="pm-badge pm-badge--blue">
          <img data-src="{{ '/logos/payment-form/icon-credit-card.svg' | blobstorage }}" alt="">
        </span>

        <h2 class="pm-card-title">{{'Tarjeta de crédito o débito' | translate}}</h2>
        <p class="pm-card-subtitle">{{'Pago en línea' | translate}}</p>

        <div class="pm-card-info">
          <p class="pm-card-label mb-3">{{'Medios de pago' | translate}}</p>
          <ul class="pm-logos">
            <li><img loading="lazy" class="pm-logo pm-logo--visa" data-src="{{ '/cards/logo-visa.svg' | blobstorage }}" alt="Visa"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--mastercard"data-src="{{ '/cards/logo-mastercard.svg' | blobstorage }}" alt="Mastercard"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--amex" data-src="{{ '/cards/logo-amex.svg' | blobstorage }}" alt="American Express"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--paypal" data-src="{{ '/cards/logo-paypal-v2.svg' | blobstorage }}" alt="PayPal"></li>
          </ul>
        </div>

        <p class="pm-tag pm-tag--green p-2 mb-3">
          <img data-src="{{ '/logos/payment-form/icon-check.svg' | blobstorage }}" alt="">
          <span>{{'Acreditación: Inmediata' | translate}}</span>
        </p>

        <p class="pm-card-desc mb-3">{{'Al confirmarse tu pago, tus servicios se activan de inmediato.' | translate}}</p>
      </article>
    </li>

    <!-- Transferencia SPEI -->
    <li>
      <article class="pm-card">
        <span class="pm-badge pm-badge--purple">
          <img data-src="{{ '/logos/payment-form/icon-spei.svg' | blobstorage }}" alt="">
        </span>

        <h2 class="pm-card-title">{{'Transferencia SPEI' | translate}}</h2>
        <p class="pm-card-subtitle">{{'Transferencia interbancaria' | translate}}</p>

        <div class="pm-card-info">
          <p class="pm-card-label mb-3">{{'Sistema' | translate}}</p>
          <ul class="pm-logos">
            <li><img loading="lazy" class="pm-logo pm-logo--spei" data-src="{{ '/logos/openpay/logo-spei.svg' | blobstorage }}" alt="SPEI"></li>
          </ul>
        </div>

        <p class="pm-tag pm-tag--orange p-2 mb-3">
          <img data-src="{{ '/logos/payment-form/icon-clock.svg' | blobstorage }}" alt="">
          <span>{{'Acreditación: Hasta 120 minutos tras confirmar' | translate}}</span>
        </p>

        <p class="pm-card-desc mb-3">{{'El tiempo de confirmación varía según tu banco emisor y el horario en que realices la transferencia.' | translate}}</p>

        <p class="pm-card-note">
          <img data-src="{{ '/logos/payment-form/icon-alert.svg' | blobstorage }}" alt="">

          <span><strong>{{'Método no disponible para el registro de dominios' | translate}}</strong> .com, .net, .lat, .autos, .lol, .mom, .xyz, .cc {{'y' | translate}} .tv</span>
        </p>
      </article>
    </li>

    <!-- Pago en comercios -->
    <li>
      <article class="pm-card">
        <span class="pm-badge pm-badge--orange">
          <img data-src="{{ '/logos/payment-form/icon-bank.svg' | blobstorage }}" alt="">
        </span>

        <h2 class="pm-card-title">{{'Pago en comercios' | translate}}</h2>
        <p class="pm-card-subtitle">{{'Tiendas y farmacias participantes' | translate}}</p>

        <div class="pm-card-info mb-3">
          <p class="pm-card-label mb-3">{{'Comercios participantes' | translate}}</p>

          <ul class="pm-logos">
            <li><img loading="lazy" class="pm-logo pm-logo--soriana" data-src="{{ '/logos/openpay/paynet/logo-soriana.svg' | blobstorage }}" alt="Soriana"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--walmart" data-src="{{ '/logos/openpay/paynet/logo-walmart.svg' | blobstorage }}" alt="Walmart"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--walmart-express" data-src="{{ '/logos/openpay/paynet/logo-walmart-express.svg' | blobstorage }}" alt="Walmart Express"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--bodega" data-src="{{ '/logos/openpay/paynet/logo-bodega-aurrera.svg' | blobstorage }}" alt="Bodega Aurrerá"></li>
          </ul>

          <ul class="pm-logos pm-logos--wide">
            <li><img loading="lazy" class="pm-logo pm-logo--farmacias" data-src="{{ '/logos/openpay/paynet/logo-farmacia-guadalajara.svg' | blobstorage }}" alt="Farmacias Guadalajara"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--fa" data-src="{{ '/logos/openpay/paynet/logo-farmacias-del-ahorro.svg' | blobstorage }}" alt="Farmacias del Ahorro"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--seven" data-src="{{ '/logos/openpay/paynet/logo-7-eleven.svg' | blobstorage }}" alt="7-Eleven"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--waldos" data-src="{{ '/logos/openpay/paynet/logo-waldos.svg' | blobstorage }}" alt="Waldos"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--circlek" data-src="{{ '/logos/openpay/paynet/logo-k.svg' | blobstorage }}" alt="Circle K"></li>
          </ul>

          <ul class="pm-logos pm-logos--wide">
            <li><img loading="lazy" class="pm-logo pm-logo--extra" data-src="{{ '/logos/openpay/paynet/logo-extra.svg' | blobstorage }}" alt="Tiendas Extra"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--kiosko" data-src="{{ '/logos/openpay/paynet/logo-kiosko.svg' | blobstorage }}" alt="Kiosko"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--systienda" data-src="{{ '/logos/openpay/paynet/logo-sys-tienda.svg' | blobstorage }}" alt="SYS Tienda"></li>
            <li><img loading="lazy" class="pm-logo pm-logo--sams" data-src="{{ '/logos/openpay/paynet/logo-sams.svg' | blobstorage }}" alt="Sam's Club"></li>
          </ul>
        </div>

        <p class="pm-tag pm-tag--orange p-2 mb-3">
          <img data-src="{{ '/logos/payment-form/icon-clock.svg' | blobstorage }}" alt="">
          <span>{{'Acreditación: Hasta 120 minutos tras confirmar' | translate}}</span>
        </p>

        <p class="pm-card-desc mb-3">{{'El tiempo de confirmación varía según el comercio y el horario en que realices tu pago.' | translate}}</p>

        <p class="pm-card-note">
          <img data-src="{{ '/logos/payment-form/icon-alert.svg' | blobstorage }}" alt="">
          <span><strong>{{'Método no disponible para el registro de dominios' | translate}}</strong> .com, .net, .lat, .autos, .lol, .mom, .xyz, .cc {{'y' | translate}} .tv</span>
        </p>
      </article>
    </li>

    <!-- Depósito bancario -->
    <li>
      <article class="pm-card">
        <span class="pm-badge pm-badge--orange">
          <img data-src="{{ '/logos/payment-form/icon-bank.svg' | blobstorage }}" alt="">
        </span>

        <h2 class="pm-card-title">{{'Depósito bancario' | translate}}</h2>
        <p class="pm-card-subtitle">{{'Pago referenciado o cuenta de cheques' | translate}}</p>

        <div class="pm-card-info">
          <p class="pm-card-label mb-3">{{'Banco' | translate}}</p>
          <ul class="pm-logos">
            <li><img loading="lazy" class="pm-logo pm-logo--bbva" data-src="{{ '/cards/logo-bbva.svg' | blobstorage }}" alt="BBVA"></li>
          </ul>
        </div>

        <p class="pm-tag pm-tag--orange p-2 mb-3">
          <img data-src="{{ '/logos/payment-form/icon-clock.svg' | blobstorage }}" alt="">
          <span>{{'Acreditación: de 1 a 3 días hábiles' | translate}}</span>
        </p>

        <p class="pm-card-desc mb-3">{{'Si pagas en efectivo, banca en línea o con cheque BBVA, tu pago se confirma en 1 día hábil. Si pagas con cheque de otro banco, la confirmación tarda de 2 a 3 días hábiles.' | translate}}</p>

        <p class="pm-card-note">
          <img data-src="{{ '/logos/payment-form/icon-alert.svg' | blobstorage }}" alt="">
          <span><strong>{{'Método no disponible para el registro de dominios' | translate}}</strong> .com, .net, .lat, .autos, .lol, .mom, .xyz, .cc {{'y' | translate}} .tv</span>
        </p>
      </article>
    </li>

  </ul>
</section>
